import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../service/api.js";
import router from "../../../router/index.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        item : []
    },

    mutations: {
        course(state, obj) {
            state.item = obj;
        }
    },

    actions: {
        config({commit}, data) {
            return Service.course('exp', data, {})
                .then((response) => {
                    store.commit("courses/course", response.data.data)
                    return response

                }).catch((err) => {
            });
        },
        create({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.course('post', {...data}, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    return store.dispatch("courses/config", {}).then(() => response)
                }).catch((err) => {
                    store.commit("dialog/loading",false)
            });
        },
        update({commit}, data) {
            store.commit("dialog/loading",true)
            return Service.course('put', data, {})
                .then((response) => {
                    store.commit("dialog/loading",false)
                    store.commit("dialog/toasts",1)
                    return store.dispatch("courses/config", {}).then(() => response)
                }).catch((err) => {
                    store.commit("dialog/loading",false)
            });
        },
    },

    getters: {
        course(state, obj) {
            return state.item;
        },
    },
};

export default ServerModule;
